import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RtUICoreModule } from '../core/core.module';
import { AddLineModule } from './add-line/add-line.module';
import { AdminsAvatarsModule } from './admins-avatars/admins-avatars.module';
import { AdminsSelectDialogFormModule } from './admins-select-dialog-form/admins-select-dialog-form.module';
import { AvatarModule } from './avatar/avatar.module';
import { BadgeModule } from './badge/badge.module';
import { BoxModule } from './box/box.module';
import { ButtonNewModule } from './button-new/button-new.module';
import { ButtonModule } from './button/button.module';
import { CandidateRatingModule } from './candidate-rating/candidate-rating.module';
import { CardModule } from './card/card.module';
import { CircularProgressIndicatorModule } from './circular-progress-indicator/circular-progress-indicator.module';
import { DateModule } from './date/date.module';
import { DividerModule } from './divider/divider.module';
import { DotModule } from './dot/dot.module';
import { PreventDragdropModule } from './drag-and-drop/prevent-dragdrop.module';
import { DropdownModule } from './dropdown/dropdown.module';
import { EmptyStateModule } from './empty-state/empty-state.module';
import { FabButtonModule } from './fab-button/fab-button.module';
import { GroupModule } from './group/group.module';
import { HeadingModule } from './heading/heading.module';
import { HotkeyModule } from './hotkey/hotkey.module';
import { IconHelpModule } from './icon-help/icon-help.module';
import { IconModule } from './icon/icon.module';
import { InterviewEvaluationRatingModule } from './interview-evaluation-rating/interview-evaluation-rating.module';
import { ItemModule } from './item/item.module';
import { LabelModule } from './label/label.module';
import { LatinizeService } from './latinize.service';
import { LinesRatingModule } from './lines-rating/lines-rating.module';
import { LinkModule } from './link/link.module';
import { ListModule } from './list/list.module';
import { MailPickerModule } from './mail-picker/mail-picker.module';
import { MessageModule } from './message/message.module';
import { OfferStatusIndicatorModule } from './offer-status-indicator/offer-status-indicator.module';
import { PaginationCounterModule } from './pagination-counter/pagination-counter.module';
import { PaginationModule } from './pagination/pagination.module';
import { PipesModule } from './pipes/pipes.module';
import { PlaceloaderModule } from './placeloader/placeloader.module';
import { ProgressBarModule } from './progress-bar/progress-bar.module';
import { ProgressModule } from './progress/progress.module';
import { ResultsLimitButtonModule } from './results-limit-button/results-limit-button.module';
import { SegmentedControlButtonModule } from './segmented-control/segmented-control-button/segmented-control-button.module';
import { SegmentedControlModule } from './segmented-control/segmented-control.module';
import { SpinnerModule } from './spinner/spinner.module';
import { StarsRatingModule } from './stars-rating/stars-rating.module';
import { TableModule } from './table/table.module';
import { TabsModule } from './tabs/tabs.module';
import { TagModule } from './tag/tag.module';
import { ToolbarGroupModule } from './toolbar/toolbar-group/toolbar-group.module';
import { ToolbarPrimaryModule } from './toolbar/toolbar-primary/toolbar-primary.module';
import { ToolbarSecondaryModule } from './toolbar/toolbar-secondary/toolbar-secondary.module';
import { ToolbarModule } from './toolbar/toolbar/toolbar.module';
import { TooltipModule } from './tooltip/tooltip.module';
import { TruncateModule } from './truncate/truncate.module';
import { WindowRef } from './window-ref';

const COMPONENT_MODULES = [
  AvatarModule,
  BadgeModule,
  BoxModule,
  CardModule,
  IconModule,
  SpinnerModule,
  TabsModule,
  TooltipModule,
  EmptyStateModule,
  DividerModule,

  DateModule,
  DotModule,
  MessageModule,
  AddLineModule,
  AdminsAvatarsModule,
  AdminsSelectDialogFormModule,
  ButtonModule,
  ButtonNewModule,
  CandidateRatingModule,
  CircularProgressIndicatorModule,
  PreventDragdropModule,
  DropdownModule,
  HeadingModule,
  HotkeyModule,
  GroupModule,
  TruncateModule,
  InterviewEvaluationRatingModule,
  IconHelpModule,
  ItemModule,
  LabelModule,
  LinesRatingModule,
  LinkModule,
  ListModule,
  MailPickerModule,
  OfferStatusIndicatorModule,
  PaginationModule,
  PaginationCounterModule,
  PlaceloaderModule,
  ProgressModule,
  ProgressBarModule,
  SegmentedControlButtonModule,
  SegmentedControlModule,
  StarsRatingModule,
  TableModule,
  TagModule,
  ToolbarModule,
  ToolbarGroupModule,
  ToolbarPrimaryModule,
  ToolbarSecondaryModule,
  ResultsLimitButtonModule,
  FabButtonModule,
];

@NgModule({
  imports: [FormsModule, ReactiveFormsModule, RtUICoreModule, PipesModule, ...COMPONENT_MODULES],
  declarations: [],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    RtUICoreModule,
    BadgeModule,
    PipesModule,
    ...COMPONENT_MODULES,
  ],
})
export class RtUICommonModule {
  public static forRoot(): ModuleWithProviders<RtUICommonModule> {
    return { ngModule: RtUICommonModule, providers: [WindowRef, LatinizeService] };
  }
}
